export function isIterable(object) {
    return typeof object[Symbol.iterator] == 'function'
}
  
export function dfsTraverse(rootNode, callback) {
    const stack = [rootNode]
    while (stack.length > 0) {
        let node = stack.pop()
        callback(node)
        if (node.children) {
            stack.push(...node.children)
        }
    }
}

/**
 * 创建元素
 * @param {*} tag 标签名
 * @param  {...any} children 子节点
 * @returns 
 */
export function createElement(tag, ...children) {
  let el = document.createElement(tag)
  el.append(...children.flat(Infinity))
  return el
}